<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="成员名称">
              <a-input
                placeholder="请输入成员名称"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="账号">
              <a-input
                placeholder="输入账号查询"
                v-model="queryParam.userId"
              ></a-input>
            </a-form-item>
          </a-col>

          <!--按下展开按钮时出现的部分-->
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item label="性别">
                <a-select v-model="queryParam.gender" placeholder="请选择性别">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="MALE">男</a-select-option>
                  <a-select-option value="FEMALE">女</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="手机号码">
                <a-input
                  placeholder="请输入手机号码查询"
                  v-model="queryParam.mobile"
                ></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item label="激活状态">
                <a-select v-model="queryParam.status" placeholder="请选择">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">已激活</a-select-option>
                  <a-select-option value="2">已禁用</a-select-option>
                  <a-select-option value="4">未激活</a-select-option>
                  <a-select-option value="5">退出企业</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="客户联系">
                <a-select v-model="queryParam.isFlag" placeholder="请选择">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">已开启</a-select-option>
                  <a-select-option value="0">未开启</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <!--按下展开按钮时出现的部分结束-->

          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <!--展开按钮，控制toggleSearchStatus状态-->
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
              <!--展开按钮结束-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新增成员</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <!--下拉栏显示的菜单， 通过slot="overlay"控制-->
        <a-menu slot="overlay">
          <!--  批量删除操作        -->
          <a-menu-item @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <!--下拉菜单的默认显示结束-->
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="(record, index) => index"
        @change="handleTableChange"
      >
        <template slot="avatarslot" slot-scope="text, record">
          <div class="anty-img-wrap">
            <a-avatar
              shape="square"
              :src="getAvatarView(record.avatar)"
              icon="user"
            />
          </div>
        </template>

        <span slot="custNum" slot-scope="text, record">
          <!-- <router-link :to="{ path: '/wechatwork/customer/wxCustomerList', query: { userId: record.userid } }"
            >{{ text }}
          </router-link> -->

          <span
            style="color:#327CF6;cursor:pointer"
            @click="goRoute(record.userid)"
          >
            {{ text }}
          </span>
        </span>
        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a @click="JumpChatInfoview(record)">消息</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="addWelcome(record)">欢迎语</a>
              </a-menu-item>
              <!--<a-menu-item>-->
              <!--  <a @click="customerInherit(record)">客户继承</a>-->
              <!--</a-menu-item>-->
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <member-modal
      ref="modalForm"
      @ok="modalFormOk"
      @searchReset="searchReset"
    ></member-modal>
    <material-component
      ref="materialForm"
      @ok="modalFormOk"
    ></material-component>

    <a-modal
      v-model="showCustomerModal"
      width="800px"
      title="客户继承"
      @ok="handleOk"
    >
      <div>
        <span>选择继承人：</span>
        <a-select
          default-value="请选择"
          style="width: 120px;"
          @change="handleSelect"
        >
          <a-select-option
            v-for="item in inheritData"
            :key="item.id"
            :value="item.name"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="inherit-info">
        <span>{{ selectedRecord.name }}</span>
        <span>{{ selectedSu }}</span>
      </div>
      <div>
        <a-transfer
          :data-source="customerData"
          :list-style="{ width: '250px', height: '300px' }"
          :target-keys="targetKeys"
          :render="item => `${item.name}-${item.company}`"
          @change="handleChange"
        >
          <span slot="notFoundContent">
            没数据
          </span>
        </a-transfer>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import MemberModal from './MemberModal';
import materialComponent from '../material/materialComponent';
import { getFileAccessHttpUrl } from '@/api/manage';
import { deleteCus, deleteBatchCus } from '@/api/api';

import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JImageUpload from '@/components/jeecg/JImageUpload';

export default {
  name: 'UserList',
  mixins: [JeecgListMixin],
  components: {
    MemberModal,
    JImageUpload,
    materialComponent
  },
  data() {
    return {
      queryParam: {
        externalUserId: this.$route.query.externalUserId
      },
      columns: [
        {
          title: '账号',
          align: 'center',
          dataIndex: 'userid',
          width: 120
        },
        {
          title: '成员名称',
          align: 'center',
          width: 100,
          dataIndex: 'name'
        },
        {
          title: '手机号码',
          align: 'center',
          width: 120,
          dataIndex: 'mobile'
        },

        // {
        //   title: '所属部门',
        //   align: 'center',
        //   width: 80,
        //   dataIndex: 'departIds',
        //   sorter: true
        // },
        // {
        //   title: '职务信息',
        //   align: 'center',
        //   width: 100,
        //   dataIndex: 'position'
        // },
        {
          title: '性别',
          align: 'center',
          width: 100,
          //dataIndex: 'gender',
          customRender: function(text, record, index) {
            if (record.gender === '1') {
              return '男';
            } else if (record.gender === '2') {
              return '女';
            } else {
              return '无';
            }
          }
        },
        // {
        //   title: '邮箱',
        //   align: 'center',
        //   width: 180,
        //   dataIndex: 'email'
        // },
        {
          title: '头像',
          align: 'center',
          width: 130,
          dataIndex: 'avatar',
          scopedSlots: {
            customRender: 'avatarslot'
          }
        },
        {
          title: '激活状态',
          align: 'center',
          width: 80,
          dataIndex: 'status',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '已激活';
            } else if (text == 2) {
              return '已禁用';
            } else if (text == 4) {
              return '未激活';
            } else if (text == 5) {
              return '退出企业';
            } else {
              return text;
            }
          }
        },
        {
          title: '客户联系',
          align: 'center',
          width: 80,
          dataIndex: 'isFlag',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '已开启';
            } else if (text == 2 || text == 0) {
              return '未开启';
            }
          }
        },
        {
          title: '客户数',
          align: 'center',
          width: 130,
          dataIndex: 'customerNum',
          scopedSlots: {
            customRender: 'custNum'
          }
        },
        {
          title: '消息数',
          align: 'center',
          width: 130,
          dataIndex: 'messageNum'
        },
        {
          title: '当日消息数',
          align: 'center',
          width: 130,
          dataIndex: 'todayMessageNum'
        },
        {
          title: '最新消息时间',
          align: 'center',
          width: 130,
          dataIndex: 'lastMessageTime',
          customRender: function(text, record, index) {
            if (text == null) {
              return '-';
            } else {
              return text;
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center',
          width: 170
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerService/data',
        delete:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/market/userDelete',
        deleteBatch:
          process.env.VUE_APP_WECHATCUSTOMER +
          '/wechatwork/market/userDeleteBatch'
      },
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      showCustomerModal: false,
      customerData: [], //当前选中的员工的外部联系人
      targetKeys: [], //选中的目标
      inheritData: [], //继承者
      selectedSu: '',
      selectedRecord: {}
    };
  },
  // inject: ['reload'],
  mounted() {
    this.getMock();
  },
  methods: {
    goRoute(params) {
      this.$router.push({
        path: '/wechatwork/customer/wxCustomerList',
        query: {
          userId: params
        }
      });
    },
    oncloseWelcome() {
      this.welcomeModel = false;
      (this.form.linkPicurlId = ''),
        (this.form.imageMediaId = ''),
        (this.form.miniprogramPicMediaId = '');
    },
    btn(record) {
      this.$router.push({
        path: '/wechatwork/customer/wxCustomerList',
        query: { userId: record.userid }
      });
      // path: '/wechatwork/customer/wxCustomerList', query: { userId: record.userid }
    },
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    //批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var userIds = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          userIds += this.selectionRows[a].userid + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            //   that.loading = true
            let formData = new FormData();
            formData.userIdList = userIds;
            deleteBatchCus(formData)
              .then(res => {
                if (res.success) {
                  that.$message.success('删除成功！');
                } else {
                  that.$message.error(res.message);
                }
              })
              .finally(() => {
                //       that.loading = false
                this.searchReset();
                // that.reload();
              });
          }
        });
      }
    },
    handleDelete(record) {
      const that = this;
      let formData = new FormData();
      formData.userId = record.userid;
      deleteCus(formData).then(res => {
        if (res.success) {
          that.$message.success('删除成功！');
          this.searchReset();
          // that.reload();
        } else {
          that.$message.error(res.message);
          this.searchReset();
          // that.reload();
        }
      });
    },

    addWelcome(record) {
      this.$refs.materialForm.add(record);
    },

    JumpChatInfoview(record) {
      console.log(record);
      this.$router.push({
        // path: '/wechatwork/supervision/chatDataList',
        // query: {
        //   userId: record.userid,
        //   userName:record.name,
        //   type: 1
        // }
        path: '/wechatwork/supervision/chatDataListRe',
        query: {
          condition: record.name,
          type: 1,
          sendId: record.userid,
          externalId: '',
          chatTypeFlg: '0'
        }
      });
    },
    //客户继承
    customerInherit(record) {
      console.log(record);
      this.selectedRecord = record;
      this.showCustomerModal = true;
    },
    handleOk() {
      this.showCustomerModal = false;
    },
    getMock() {
      this.customerData = [
        {
          key: '1',
          name: '周娇',
          company: '佳锐',
          chosen: false
        },
        {
          key: '2',
          name: '杜世杰',
          company: '佳锐',
          chosen: true
        },
        {
          key: '3',
          name: '扶晨玲',
          company: '佳锐',
          chosen: false
        },
        {
          key: '4',
          name: '王明溪',
          company: '佳锐',
          chosen: false
        },
        {
          key: '5',
          name: '陈思瀚',
          company: '佳锐',
          chosen: false
        },
        {
          key: '6',
          name: '丁建',
          company: '佳锐',
          chosen: false
        },
        {
          key: '7',
          name: '付阳',
          company: '佳锐',
          chosen: true
        },
        {
          key: '8',
          name: '冯金雪',
          company: '佳锐',
          chosen: false
        },
        {
          key: '9',
          name: '杨羊',
          company: '佳锐',
          chosen: true
        },
        {
          key: '10',
          name: '王康岚',
          company: '佳锐',
          chosen: false
        },
        {
          key: '11',
          name: '章娇',
          company: '佳锐',
          chosen: false
        },
        {
          key: '12',
          name: '张婉莹',
          company: '佳锐',
          chosen: true
        },
        {
          key: '13',
          name: '付阳',
          company: '佳锐',
          chosen: false
        },
        {
          key: '14',
          name: '岳硕',
          company: '佳锐',
          chosen: false
        }
      ];
      this.inheritData = [
        {
          id: '1',
          name: '王超'
        },
        {
          id: '2',
          name: '李玲'
        },
        {
          id: '3',
          name: '李军'
        },
        {
          id: '4',
          name: '王超越'
        },
        {
          id: '5',
          name: '周云'
        },
        {
          id: '6',
          name: '贺翔'
        }
      ];

      this.customerData.forEach(item => {
        if (item.chosen) {
          this.targetKeys.push(item.key);
        }
      });
    },
    handleChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys);
      this.targetKeys = targetKeys;
    },
    handleSelect(value) {
      this.selectedSu = value;
      console.log(value);
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.inherit-info {
  height: 40px;
  line-height: 40px;
}
.inherit-info span {
  display: inline-block;
}
.inherit-info span:first-child {
  width: 290px;
}
</style>
